export default class CreateController
{
	constructor($scope, $http, $location) {
		this.$scope = $scope;
		this.$http = $http;
		this.$location = $location;
		this.$scope.$parent.title = 'Create record';

		this.success = false;

		this.attributes = {
			date_visited: new Date(),
			visitor_type: 'FIT',
			visitor_origin: 'Domestic'
		};
	}

	submit() {
		this.create();
	}

	create() {
		this.$http({
			method: 'POST',
			url: '/api/records',
			data: this.attributes
		}).then((response) => {
			this.success = true;
			this.$location.url('/records');
		}, (response) => {
			alert('Unable to add record');
		});
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/records/create.controller.js
 **/